import React, { useState, useEffect } from "react";
import Body from "../../Common/Body";
import moment from "moment";
import ContentCard from "../../Common/Layout/ContentCard";
import useFetch from "../../../hooks/useFetch";
import { StockTable } from "./StockTable";
import { StockTotals } from "./StockTotals";
import { Box, Heading } from "@chakra-ui/react";

const Stock = () => {
  moment.locale();
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataFetched, setDataFetched] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({});

  const { get } = useFetch();

  useEffect(() => {
    setIsLoading(true);
    let url = `/reports/stock?page=${currentPage}&`;
    Object.keys(filters).forEach((key) => {
      url += key + "=" + filters[key] + "&";
    });

    get(url)
      .then(async (res) => {
        setDataFetched(res);
        setMaxPagination(res.total);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      })
      .finally(() => setIsLoading(false));
  }, [currentPage, filters]);

  const handleSelectedPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Body title={"Reporte de stock valorizado"}>
        <ContentCard>
          <Box flex="1" textAlign="left">
            <Heading variant="h2" pb={"0.5rem"}>
              Suma de costos
            </Heading>
          </Box>
          <StockTotals costs={dataFetched.costs} />
        </ContentCard>
        <ContentCard>
          <StockTable
            filters={filters}
            setFilters={setFilters}
            isLoading={isLoading}
            maxPagination={maxPagination}
            currentPage={currentPage}
            products={dataFetched.products}
            handleSelectedPage={handleSelectedPage}
          ></StockTable>
        </ContentCard>
      </Body>
    </>
  );
};

export default Stock;
